import { createRoot } from 'react-dom/client'
import './assets/styles/globals.css'
import App from './App.tsx'
import { ToastProvider } from './hooks/useToast'

createRoot(document.getElementById('root')!).render(
  <ToastProvider>
    <App />
  </ToastProvider>,
)
